import { graphql } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../layouts/default";
import BGImageHero from "../sections/BGImageHero";
import FoundersNote from "../sections/FoundersNote";
import FoundersSection from "../sections/FoundersSection";

export const query = graphql`
  {
    contentfulAboutFoundersJourney {
      backgroundHero {
        fluid(maxWidth: 1440, quality: 100) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      heroHeadline
      foundersNoteText {
        raw
      }
      foundersNoteIntro {
        raw
      }
      foundersNoteImage {
        fluid(maxWidth: 1440, quality: 100) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      founders {
        image {
          fluid(maxWidth: 1440, quality: 100) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        name
        title
        bio {
          raw
        }
      }
    }
  }
`;

export default function FoundersJourney({ data, location }) {
  const foundersJourney = data.contentfulAboutFoundersJourney;

  return (
    <Layout pathName={location.pathname}>
      <Helmet>
        <title>Founders' Journey</title>
      </Helmet>
      <BGImageHero text="Founders' Journey" image={foundersJourney.backgroundHero.fluid} />
      <FoundersNote
        intro={foundersJourney.foundersNoteIntro}
        text={foundersJourney.foundersNoteText}
        image={foundersJourney.foundersNoteImage}
      />
      <FoundersSection
        founders={foundersJourney.founders}
      />
    </Layout>
  );
}
